import { defineStore } from 'pinia';
import { ref } from 'vue';

export type ProjectFieldApplyArgs = {
  fieldPath: string;
  original: string;
  revised: string;
};

type FieldApplyHandler = (args: ProjectFieldApplyArgs) => boolean;

type HandlerRegistration = {
  draftKey: string;
  token: number;
  fn: FieldApplyHandler;
};

/** 创建页左侧表单应用 AI 改写（由 ProjectCreate 注册具体逻辑） */
export const useProjectCreateFieldApplyStore = defineStore('projectCreateFieldApply', () => {
  const applyHandler = ref<HandlerRegistration | null>(null);
  let nextToken = 0;

  function registerApplyHandler(draftKey: string, fn: FieldApplyHandler): number {
    const token = ++nextToken;
    applyHandler.value = { draftKey: String(draftKey || '').trim(), token, fn };
    return token;
  }

  function clearApplyHandler(token?: number) {
    if (token == null || applyHandler.value?.token === token) {
      applyHandler.value = null;
    }
  }

  function applyFieldReplace(args: ProjectFieldApplyArgs, draftKey = ''): boolean {
    const active = applyHandler.value;
    const targetDraftKey = String(draftKey || '').trim();
    if (!active || (targetDraftKey && active.draftKey !== targetDraftKey)) return false;
    return active.fn(args);
  }

  return {
    registerApplyHandler,
    clearApplyHandler,
    applyFieldReplace,
  };
});
